module.exports = __webpack_public_path__ + "img/hz1.12d4b70b.png";